import React from "react";
import { Group } from '@visx/group';
import { AxisBottom, AxisLeft } from '@visx/axis';
import { scaleLinear, scaleBand } from '@visx/scale';
import { Bar } from '@visx/shape';

export const background = '#fff';
const defaultMargin = { top: 8, right: 32, bottom: 70, left: 60 }; // Adjusted left margin for y-axis labels

export default function Results({ BMR, width, height, margin = defaultMargin }) {
    const xMax = width - margin.left - margin.right;
    const yMax = height - margin.top - margin.bottom;

    const topXScale = (BMR > 2000) ? 6000 : 4000

    // Define xScale for the bars' width
    const xScale = scaleLinear({
        domain: [0, topXScale],
        range: [0, xMax]
    });

    // Define yScale as a band scale for positioning bars and labels
    const yScale = scaleBand({
        domain: ['Base', 'Sedentaire', 'Actif', 'Sportif'],  // Names as domain for axis labels
        range: [0, yMax],
        padding: 0.2  // Adds padding between bars
    });

    // Data for bars, each with a multiplier and color
    const bmrLimits = [
        { lifestyle: 'Base', multiplier: 1, color: "#fde68a" },
        { lifestyle: 'Sedentaire', multiplier: 1.37, color: "#fbbf24" },
        { lifestyle: 'Actif', multiplier: 1.55, color: "#f59e0b" },
        { lifestyle: 'Sportif', multiplier: 1.8, color: "#d97706" }
    ];

    return (
        <div className='mx-auto'>
            <svg width={width} height={height} style={{ background }}>
                <Group>
                    {bmrLimits.map((item) => {

                        return (
                            BMR &&
                            <>
                                <Bar
                                    key={item.lifestyle}
                                    x={margin.left}
                                    y={yScale(item.lifestyle)}
                                    fill={item.color}
                                    height={yScale.bandwidth()}
                                    width={xScale(BMR * item.multiplier)}
                                />
                                <text
                                    x={margin.left + xScale(BMR * item.multiplier) + 5}
                                    y={yScale(item.lifestyle) + (yScale.bandwidth() / 2) + 4}
                                    textAnchor="start"
                                    fontSize={12}
                                    className="font-semibold"
                                    fill="#000"
                                >
                                    {`${(BMR * item.multiplier).toFixed(0)} kcal`}
                                </text>
                            </>
                        )
                    })}
                </Group>
                <AxisBottom
                    scale={xScale}
                    top={height - margin.bottom} // Position the axis at the bottom
                    left={margin.left} // Offset by the left margin
                    numTicks={4} // Adjust number of ticks as needed
                />
                <AxisLeft
                    scale={yScale} // Use yScale for the y-axis
                    left={margin.left} // Position axis along the left margin
                />
            </svg>
        </div>
    );
}
